module.exports = __webpack_public_path__ + "static/img/利害關係人溝通01EN.fb7dd9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/利害關係人溝通01EN.jpg
// module id = jIos
// module chunks = 1